import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const I18nContext = createContext();
export const useT = () => useContext(I18nContext);

const dict = {
  cs: {
    "nav.features": "Funkce",
    "nav.pricing": "Ceník",
    "nav.dashboard": "Dashboard",
    "nav.login": "Přihlášení",
    "nav.register": "Registrace",
    "nav.logout": "Odhlásit",
    "landing.tag": "Pokročilá AI pro forex, krypto a prop firm tradery",
    "landing.h1": "Obchoduj chytřeji. S AI partnerem na úrovni instituce.",
    "landing.sub": "AI mentor pro tradery: analyzuje tvé grafy ze screenshotu, hlídá pravidla prop firm challenge a vede tvůj obchodní deník s důrazem na risk management a trading disciplínu — vše v jedné platformě.",
    "landing.cta": "Spustit zdarma",
    "landing.cta2": "Vidět ukázku",
    "landing.feat1.title": "AI analýza grafů",
    "landing.feat1.desc": "Nahraj screenshot z TradingView, MT5, Binance — dostaň BUY/SELL/WAIT s entry, SL, TP1-3 a důvody.",
    "landing.feat2.title": "Prop Firm Guardian",
    "landing.feat2.desc": "Hlídáme tvůj prop firm účet a pravidla challenge. Žádné porušení pravidel.",
    "landing.feat3.title": "AI Trading Mentor",
    "landing.feat3.desc": "Polož otázku jako profesionálnímu mentorovi 24/7. Najdi své chyby a zlepšuj se.",
    "landing.feat4.title": "Trading deník",
    "landing.feat4.desc": "Win rate, profit factor, equity křivka. Statistiky, které posunou tvůj edge.",
    "landing.feat5.title": "Market Scanner",
    "landing.feat5.desc": "Sledujeme BTC, ETH, EURUSD, XAUUSD, NASDAQ. Včas tě upozorníme.",
    "landing.feat6.title": "Risk modes",
    "landing.feat6.desc": "Konzervativní, standardní, agresivní. AI přizpůsobí každé doporučení.",
    "landing.pricing.title": "Vyber si svůj plán",
    "landing.pricing.free": "Pro začátek",
    "landing.pricing.pro": "Pro aktivní tradery",
    "landing.pricing.elite": "Pro prop firm profesionály",
    "landing.month": "/měsíc",
    "landing.cta.free": "Začít zdarma",
    "landing.cta.upgrade": "Upgrade",
    "landing.footer": "Obchodování s pákovými produkty nese vysoké riziko ztráty. TradeMind AI poskytuje analytické nástroje, nikoli investiční poradenství.",
    "auth.login.title": "Přihlas se",
    "auth.login.sub": "Vrať se do své obchodní centrály",
    "auth.register.title": "Vytvoř účet",
    "auth.register.sub": "Začni 3 AI analýzami denně zdarma",
    "auth.email": "Email",
    "auth.password": "Heslo",
    "auth.name": "Jméno a příjmení",
    "auth.submit.login": "Přihlásit",
    "auth.submit.register": "Vytvořit účet",
    "auth.switch.toRegister": "Nemáš účet? Registruj se",
    "auth.switch.toLogin": "Máš účet? Přihlas se",
    "auth.google": "Pokračovat přes Google",
    "auth.or": "nebo",
    "dash.title": "Přehled",
    "dash.subtitle": "Vítej zpět",
    "dash.plan": "Plán",
    "dash.analyses.today": "Analýzy dnes",
    "dash.openTrades": "Otevřené obchody",
    "dash.winrate": "Win Rate",
    "dash.totalpnl": "Celkový P/L",
    "dash.recent": "Poslední analýzy",
    "dash.empty.analyses": "Zatím žádné analýzy. Nahraj svůj první graf.",
    "dash.startAnalysis": "Nová analýza",
    "dash.equity": "Equity křivka",
    "sidebar.dashboard": "Dashboard",
    "sidebar.analyze": "Analýza grafu",
    "sidebar.journal": "Deník",
    "sidebar.propfirm": "Prop Firm",
    "sidebar.mentor": "AI Mentor",
    "sidebar.scanner": "Market Scanner",
    "sidebar.calendar": "Kalendář",
    "sidebar.calculator": "Kalkulačka",
    "sidebar.settings": "Nastavení",
    "analyze.title": "AI Analýza grafu",
    "analyze.sub": "Nahraj screenshot z TradingView, MT4, MT5, Binance, Bybit nebo cTrader",
    "analyze.drop": "Přetáhni obrázek sem nebo klikni pro výběr",
    "analyze.formats": "PNG, JPG, WEBP — max 10MB",
    "analyze.style": "Obchodní styl",
    "analyze.style.scalping": "Scalping (M1-M15)",
    "analyze.style.intraday": "Intraday (M15-H1)",
    "analyze.style.swing": "Swing (H4-D1)",
    "analyze.style.auto": "Automatická detekce",
    "analyze.risk": "Risk režim",
    "analyze.risk.conservative": "Konzervativní (0.5%)",
    "analyze.risk.standard": "Standardní (1%)",
    "analyze.risk.aggressive": "Agresivní (2%)",
    "analyze.balance": "Velikost účtu ($)",
    "analyze.notes": "Poznámky (volitelné)",
    "analyze.submit": "Analyzovat graf",
    "analyze.loading": "AI analyzuje graf...",
    "analyze.result.direction": "Směr",
    "analyze.result.confidence": "Důvěra",
    "analyze.result.entry": "Vstup",
    "analyze.result.sl": "Stop Loss",
    "analyze.result.tp1": "TP1",
    "analyze.result.tp2": "TP2",
    "analyze.result.tp3": "TP3",
    "analyze.result.rr": "RR",
    "analyze.result.grade": "Hodnocení",
    "analyze.result.reasoning": "Důvod vstupu",
    "analyze.result.invalidation": "Co setup zneplatní",
    "analyze.result.risks": "Rizika",
    "analyze.result.management": "Správa pozice",
    "analyze.result.strengths": "Silné stránky",
    "analyze.result.weaknesses": "Slabé stránky",
    "common.save": "Uložit",
    "common.cancel": "Zrušit",
    "common.delete": "Smazat",
    "common.add": "Přidat",
    "common.close": "Zavřít",
    "journal.title": "Trading Deník",
    "journal.sub": "Tvé obchody, statistiky a equity křivka",
    "journal.add": "Přidat obchod",
    "journal.winrate": "Win Rate",
    "journal.pf": "Profit Factor",
    "journal.avgrr": "Průměrné RR",
    "journal.totalpnl": "Celkový P/L",
    "journal.empty": "Zatím žádné obchody. Přidej svůj první.",
    "journal.instrument": "Instrument",
    "journal.direction": "Směr",
    "journal.entry": "Vstup",
    "journal.exit": "Výstup",
    "journal.sl": "SL",
    "journal.tp": "TP",
    "journal.lots": "Lot",
    "journal.pnl": "P/L",
    "journal.result": "Výsledek",
    "journal.result.win": "Win",
    "journal.result.loss": "Loss",
    "journal.result.be": "BE",
    "journal.result.open": "Otevřený",
    "journal.date": "Datum",
    "propfirm.title": "Prop Firm Guardian",
    "propfirm.sub": "Sleduj svůj challenge a nepřekroč žádné pravidlo",
    "propfirm.add": "Přidat účet",
    "propfirm.firm": "Prop firma",
    "propfirm.name": "Název účtu",
    "propfirm.size": "Velikost účtu ($)",
    "propfirm.daily": "Denní limit ztráty (%)",
    "propfirm.dd": "Maximální drawdown (%)",
    "propfirm.target": "Profit target (%)",
    "propfirm.balance": "Aktuální zůstatek ($)",
    "propfirm.dailyloss": "Dnešní ztráta ($)",
    "propfirm.days": "Obchodních dnů",
    "propfirm.empty": "Žádné účty. Přidej svůj první prop firm účet.",
    "propfirm.status.safe": "Bezpečný",
    "propfirm.status.warning": "Pozor",
    "propfirm.status.danger": "Kritický",
    "propfirm.recRisk": "Doporučené riziko",
    "propfirm.toTarget": "Do cíle",
    "mentor.title": "AI Trading Mentor",
    "mentor.sub": "Ptej se na cokoli — od grafu po psychologii",
    "mentor.placeholder": "Proč jsem dostal stop loss?",
    "mentor.send": "Odeslat",
    "mentor.greeting": "Ahoj! Jsem tvůj osobní AI mentor. Můžeš se mě zeptat na cokoli — analýzu obchodu, risk management, prop firm pravidla nebo trading psychologii.",
    "scanner.title": "Market Scanner",
    "scanner.sub": "Top příležitosti napříč Forex, Crypto, komodity a indexy",
    "calendar.title": "Ekonomický kalendář",
    "calendar.sub": "Klíčové události a AI komentář k volatilitě",
    "calendar.impact.high": "Vysoký",
    "calendar.impact.medium": "Střední",
    "calendar.impact.low": "Nízký",
    "settings.title": "Nastavení",
    "settings.sub": "Tvůj profil a preference",
    "settings.lang": "Jazyk",
    "settings.risk": "Výchozí risk režim",
    "settings.plan": "Plán",
  },
  en: {
    "nav.features": "Features",
    "nav.pricing": "Pricing",
    "nav.dashboard": "Dashboard",
    "nav.login": "Sign in",
    "nav.register": "Sign up",
    "nav.logout": "Sign out",
    "landing.tag": "Advanced AI for Forex, Crypto & Prop Firm traders",
    "landing.h1": "Trade smarter. With an institutional-grade AI partner.",
    "landing.sub": "Your AI trading mentor: analyzes chart screenshots, guards your prop firm challenge rules, and runs your trading journal with a focus on risk management and discipline — all in one platform.",
    "landing.cta": "Start free",
    "landing.cta2": "See demo",
    "landing.feat1.title": "AI Chart Analysis",
    "landing.feat1.desc": "Upload a screenshot from TradingView, MT5, Binance — get BUY/SELL/WAIT with entry, SL, TP1-3 and detailed reasoning.",
    "landing.feat2.title": "Prop Firm Guardian",
    "landing.feat2.desc": "We watch your prop firm account and challenge rules. No rule breaches.",
    "landing.feat3.title": "AI Trading Mentor",
    "landing.feat3.desc": "Ask a professional mentor 24/7. Find your mistakes and improve.",
    "landing.feat4.title": "Trading Journal",
    "landing.feat4.desc": "Win rate, profit factor, equity curve. The stats that sharpen your edge.",
    "landing.feat5.title": "Market Scanner",
    "landing.feat5.desc": "We track BTC, ETH, EURUSD, XAUUSD, NASDAQ — and alert you on time.",
    "landing.feat6.title": "Risk modes",
    "landing.feat6.desc": "Conservative, standard, aggressive. AI adapts every suggestion.",
    "landing.pricing.title": "Choose your plan",
    "landing.pricing.free": "For getting started",
    "landing.pricing.pro": "For active traders",
    "landing.pricing.elite": "For prop firm pros",
    "landing.month": "/month",
    "landing.cta.free": "Start free",
    "landing.cta.upgrade": "Upgrade",
    "landing.footer": "Leveraged trading carries a high risk of loss. TradeMind AI provides analytical tools, not investment advice.",
    "auth.login.title": "Welcome back",
    "auth.login.sub": "Sign in to your command center",
    "auth.register.title": "Create your account",
    "auth.register.sub": "Start with 3 free AI analyses per day",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.name": "Full name",
    "auth.submit.login": "Sign in",
    "auth.submit.register": "Create account",
    "auth.switch.toRegister": "No account yet? Sign up",
    "auth.switch.toLogin": "Have an account? Sign in",
    "auth.google": "Continue with Google",
    "auth.or": "or",
    "dash.title": "Overview",
    "dash.subtitle": "Welcome back",
    "dash.plan": "Plan",
    "dash.analyses.today": "Analyses today",
    "dash.openTrades": "Open trades",
    "dash.winrate": "Win rate",
    "dash.totalpnl": "Total P/L",
    "dash.recent": "Recent analyses",
    "dash.empty.analyses": "No analyses yet. Upload your first chart.",
    "dash.startAnalysis": "New analysis",
    "dash.equity": "Equity curve",
    "sidebar.dashboard": "Dashboard",
    "sidebar.analyze": "Chart Analysis",
    "sidebar.journal": "Journal",
    "sidebar.propfirm": "Prop Firm",
    "sidebar.mentor": "AI Mentor",
    "sidebar.scanner": "Market Scanner",
    "sidebar.calendar": "Calendar",
    "sidebar.calculator": "Calculator",
    "sidebar.settings": "Settings",
    "analyze.title": "AI Chart Analysis",
    "analyze.sub": "Upload a screenshot from TradingView, MT4, MT5, Binance, Bybit or cTrader",
    "analyze.drop": "Drag your image here or click to select",
    "analyze.formats": "PNG, JPG, WEBP — max 10MB",
    "analyze.style": "Trading style",
    "analyze.style.scalping": "Scalping (M1-M15)",
    "analyze.style.intraday": "Intraday (M15-H1)",
    "analyze.style.swing": "Swing (H4-D1)",
    "analyze.style.auto": "Auto-detect",
    "analyze.risk": "Risk mode",
    "analyze.risk.conservative": "Conservative (0.5%)",
    "analyze.risk.standard": "Standard (1%)",
    "analyze.risk.aggressive": "Aggressive (2%)",
    "analyze.balance": "Account balance ($)",
    "analyze.notes": "Notes (optional)",
    "analyze.submit": "Analyze chart",
    "analyze.loading": "AI is analyzing your chart...",
    "analyze.result.direction": "Direction",
    "analyze.result.confidence": "Confidence",
    "analyze.result.entry": "Entry",
    "analyze.result.sl": "Stop Loss",
    "analyze.result.tp1": "TP1",
    "analyze.result.tp2": "TP2",
    "analyze.result.tp3": "TP3",
    "analyze.result.rr": "RR",
    "analyze.result.grade": "Grade",
    "analyze.result.reasoning": "Reasoning",
    "analyze.result.invalidation": "Setup invalidation",
    "analyze.result.risks": "Risks",
    "analyze.result.management": "Position management",
    "analyze.result.strengths": "Strengths",
    "analyze.result.weaknesses": "Weaknesses",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.add": "Add",
    "common.close": "Close",
    "journal.title": "Trading Journal",
    "journal.sub": "Your trades, stats and equity curve",
    "journal.add": "Add trade",
    "journal.winrate": "Win Rate",
    "journal.pf": "Profit Factor",
    "journal.avgrr": "Average RR",
    "journal.totalpnl": "Total P/L",
    "journal.empty": "No trades yet. Add your first one.",
    "journal.instrument": "Instrument",
    "journal.direction": "Direction",
    "journal.entry": "Entry",
    "journal.exit": "Exit",
    "journal.sl": "SL",
    "journal.tp": "TP",
    "journal.lots": "Lots",
    "journal.pnl": "P/L",
    "journal.result": "Result",
    "journal.result.win": "Win",
    "journal.result.loss": "Loss",
    "journal.result.be": "BE",
    "journal.result.open": "Open",
    "journal.date": "Date",
    "propfirm.title": "Prop Firm Guardian",
    "propfirm.sub": "Track your challenge — never break a rule",
    "propfirm.add": "Add account",
    "propfirm.firm": "Prop firm",
    "propfirm.name": "Account name",
    "propfirm.size": "Account size ($)",
    "propfirm.daily": "Daily loss limit (%)",
    "propfirm.dd": "Max drawdown (%)",
    "propfirm.target": "Profit target (%)",
    "propfirm.balance": "Current balance ($)",
    "propfirm.dailyloss": "Today's loss ($)",
    "propfirm.days": "Days traded",
    "propfirm.empty": "No accounts yet. Add your first prop firm account.",
    "propfirm.status.safe": "Safe",
    "propfirm.status.warning": "Warning",
    "propfirm.status.danger": "Critical",
    "propfirm.recRisk": "Recommended risk",
    "propfirm.toTarget": "To target",
    "mentor.title": "AI Trading Mentor",
    "mentor.sub": "Ask anything — chart, risk, psychology",
    "mentor.placeholder": "Why did I get stopped out?",
    "mentor.send": "Send",
    "mentor.greeting": "Hi! I'm your personal AI mentor. Ask me anything — trade analysis, risk management, prop firm rules or trading psychology.",
    "scanner.title": "Market Scanner",
    "scanner.sub": "Top opportunities across Forex, Crypto, commodities and indices",
    "calendar.title": "Economic Calendar",
    "calendar.sub": "Key events with AI volatility notes",
    "calendar.impact.high": "High",
    "calendar.impact.medium": "Medium",
    "calendar.impact.low": "Low",
    "settings.title": "Settings",
    "settings.sub": "Your profile and preferences",
    "settings.lang": "Language",
    "settings.risk": "Default risk mode",
    "settings.plan": "Plan",
  },
};

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("trademind_lang") || "cs");
  useEffect(() => { localStorage.setItem("trademind_lang", lang); }, [lang]);
  const t = useCallback((key) => dict[lang]?.[key] || dict.en[key] || key, [lang]);
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
};
